const ATTENDANCE_FIELDS = ['attendance_solution', 'attendance_scenario_id', 'course_key_enabled'];

/**
 * A copy of course settings without the attendance fields, for saves that don't change attendance.
 *
 * @param {object} settings
 * @returns {object}
 */
export function omitAttendanceFields(settings) {
    return Object.fromEntries(Object.entries(settings).filter(([field]) => !ATTENDANCE_FIELDS.includes(field)));
}

export default omitAttendanceFields;
